module.exports = __webpack_public_path__ + "static/media/empty-box.851ac99d.svg";